import { LANDING_FAQ_CATEGORIES, LANDING_PILLARS } from '@/lib/landing-content'
import { PELGO_HOME_SEO, PELGO_SITE_URL, toAbsoluteUrl } from '@/lib/pelgo-seo'

const organizationId = `${PELGO_SITE_URL}/#organization`

const organizationDescription =
  'Pelgo re-engineers outplacement and severance for the modern enterprise with intelligent severance administration, next-gen outplacement, and severance maximization.'

const pillarServices = LANDING_PILLARS.map((pillar, index) => ({
  '@type': 'Service',
  '@id': `${PELGO_SITE_URL}/#service-${index + 1}`,
  name: pillar.title,
  description: pillar.description,
  provider: { '@id': organizationId },
}))

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': organizationId,
      name: 'Pelgo',
      url: PELGO_SITE_URL,
      logo: toAbsoluteUrl('/logo-black.png'),
      description: organizationDescription,
      sameAs: ['https://www.linkedin.com/company/pelgo/about/'],
    },
    {
      '@type': 'WebSite',
      '@id': `${PELGO_SITE_URL}/#website`,
      url: PELGO_SITE_URL,
      name: 'Pelgo',
      description: PELGO_HOME_SEO.description,
      publisher: { '@id': organizationId },
    },
    ...pillarServices,
    {
      '@type': 'FAQPage',
      '@id': `${PELGO_SITE_URL}/#faq`,
      mainEntity: LANDING_FAQ_CATEGORIES.flatMap((category) =>
        category.items.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      ),
    },
  ],
}

export function LandingJsonLd() {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD requires inline script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}
